var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',{staticClass:"obra-admin-controls",attrs:{"aria-label":"Controles administrativos"}},[_c('AgeRatingPickerModal',{attrs:{"value":_vm.ageRatingIds,"ageRatings":_vm.ageRatings},on:{"input":function($event){return _vm.$emit('age-rating-picked', $event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }